// Quem recebe o e-mail de contrato ativo junto com o designer (contrato.atendente).
// As chaves sao as mesmas do ATENDENTES do agencia_servidor (EmailsAtivacaoContratoService.js).
export const ATENDENTES = { priscila: 'Priscila', luana: 'Luana' };



// WEBPACK FOOTER //
// ./src/config/atendentes.js